import {ExportDefaultToggle} from './exportDefaults';

// T4-152: Xero has one export toggle, defaulted per connected organisation. The saved value lives on
// the organisation's bill_from row; a missing row or null means no Admin has saved one, shown as off
// (the value the new-design Export to Xero window starts with).

export type XeroExportDefaultField = 'projectInDescription';
export type XeroExportDefaults = Record<XeroExportDefaultField, boolean>;
export type XeroOrganization = {tenantId: string; organization: string};
export type StoredXeroBillFrom = {
	readonly integration: string;
	readonly externalId: string;
	readonly exportProjectInDescription: boolean | null | undefined;
};

export const XERO_EXPORT_DEFAULT_TOGGLES: ReadonlyArray<ExportDefaultToggle<XeroExportDefaultField>> = [
	{
		field: 'projectInDescription',
		labelId: 'invoicing.xero.project_in_description',
		helperId: 'integrations.quickbooks.export_defaults.project_name_helper',
	},
];

export const xeroExportDefaultsFor = (
	billFroms: ReadonlyArray<StoredXeroBillFrom | null> | null | undefined,
	tenantId: string
): XeroExportDefaults => {
	const row = (billFroms || []).find(b => b && b.integration === 'XERO' && b.externalId === tenantId);
	return {projectInDescription: row?.exportProjectInDescription === true};
};

export const shouldShowXeroExportDefaults = (hasFlag: boolean, organizations: ReadonlyArray<XeroOrganization>) =>
	hasFlag && organizations.length > 0;
